var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-nav-block"},_vm._l((_vm.d),function(item,index){return _c('c-nav-item',{key:("item_" + index),attrs:{"d":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }